import Board from "../components/Board";

export default function Game() {
    return (
        <Board />
    );
}